import Accordion from './accordion';
import Animations from './animations';
import Heights from './matchHeight';
import Sliders from './sliders';
import Filter from './filters';
import Menu from './menu';
import Tabs from "./tabs";
import Video from "./video";
// import Search from "./search";
import { Maps } from "./map";

window.addEventListener('DOMContentLoaded', () => {

	// Array.prototype.forEach.call(document.querySelectorAll("*"), (element) => {
	// 	element.style.outline = "1px solid #" + (Math.random() * 0xffffff << 0).toString(16);
	// });

	Accordion();
	Animations();
	Heights();
	Sliders();
	Filter();
	Menu();
	Tabs();
	Video();
	// Search();
	Maps();

	const footer = document.querySelector('.c-footer');
	let windowWidth = window.innerWidth;


	if(windowWidth > 1279) {
		testimonials();
		setFooterHeight();
	}

	window.addEventListener('resize', () => {
		windowWidth = window.innerWidth;

		setFooterHeight();

		if(windowWidth > 1279) {
			testimonials();
		}
	});
	let footerPlaceholderHeightElement = document.querySelector('.js-footer');

	function setFooterHeight() {
		let browserHeight = window.innerHeight;
		let footerHeight = footer.offsetHeight;

		if(browserHeight > footerHeight && footerPlaceholderHeightElement) {
			footer.classList.add('is-fixed');
			footerPlaceholderHeightElement.style.height = footer.offsetHeight + 'px';
		}
	}

	function testimonials() {
		const testimonials = document.querySelectorAll('.js-testimonial-item');

		testimonials.forEach((testimonial, index) => {
			testimonial.addEventListener('mouseover', () => {
				testimonials.forEach((testimonial) => {
					testimonial.parentNode.classList.remove('active-0');
					testimonial.parentNode.classList.remove('active-1');
					testimonial.parentNode.classList.remove('active-2');
				});
				console.log('active-' + index);
				testimonial.parentNode.classList.add('active-' + index);
			});
		});
	}

	if (footerPlaceholderHeightElement) {
		const observer = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
						if (entry.isIntersecting) {
								setFooterHeight();
						}
				});
		}, { threshold: 0.1 });

		observer.observe(footerPlaceholderHeightElement);
}

	const sectorItems = document.querySelectorAll('.js-sector-item');

	sectorItems.forEach((sectorItem) => {
		let hoverTimeout;

		sectorItem.addEventListener('mouseover', () => {
			hoverTimeout = setTimeout(() => {
				sectorItems.forEach((item) => {
					item.style.width = 65 / (sectorItems.length - 1) + '%';
					item.classList.remove('active');
				});
				sectorItem.style.width = '35%';
				sectorItem.classList.add('active');
			}, 300);
		});

		sectorItem.addEventListener('mouseout', () => {
			clearTimeout(hoverTimeout);
		});
	});


	const videoTrigger = document.querySelectorAll('.js-play-video');

	if(videoTrigger.length) {
		videoTrigger.forEach((trigger) => {
			trigger.addEventListener('click', () => {
				trigger.parentNode.classList.add('active');
				// get prev element
				const video = trigger.previousElementSibling;
				video.setAttribute('controls', true);
				video.play();
			});
		});
	}

	// when click js-search-trigger submit the closest form
	const searchTrigger = document.querySelectorAll('.js-search-trigger');

	if(searchTrigger.length) {
		searchTrigger.forEach((trigger) => {
			trigger.addEventListener('click', () => {
				trigger.closest('form').submit();
			});
		});
	}

	// On load get data-src and set it as src on .c-banner__video
	const bannerVideo = document.querySelector('.c-banner__video');

	if(bannerVideo) {
		const videoSrc = bannerVideo.getAttribute('data-src');
		bannerVideo.setAttribute('src', videoSrc);
	}

})
